//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IndexHeader from '@/components/IndexHeader'
import IndexSidebar from '@/components/IndexSidebar'
import IndexFooter from '@/components/IndexFooter'

export default {
  name: 'index',
  data () {
    return {
      promoWays: [{
        promoWaysTitle: '口碑营销',
        promoWaysDescription: '通过新闻稿件全网渠道扩散，树立品牌正面口碑， 建立用户对品牌的信任;'
      }, {
        promoWaysTitle: '产品评测  ',
        promoWaysDescription: '邀请金融类媒体针对品牌特色产品进行测评，横向对比，突出优势;'
      }, {
        promoWaysTitle: '金融自媒体',
        promoWaysDescription: '借助金融自媒体大号的影响力为品牌背书，获取粉丝好感度;'
      }, {
        promoWaysTitle: '趣味短视频',
        promoWaysDescription: '将枯燥的金融内容与时下热点结合，用创意包装品\n'
      }, {
        promoWaysTitle: '跨界合作',
        promoWaysDescription: '通过大数据分析用户的兴趣领域，然后结合品牌与产品进行跨界合作;'
      }, {
        promoWaysTitle: '硬广投放',
        promoWaysDescription: '以创意海报、走心视频等丰富形式强势植入大流量平台，获取流量转化'
      }
      ],
      promoAdvantages: [{
        iconName: 'shuju1',
        iconSize: '12.5vw',
        iconPosition: '-21%',
        iconLeft: '-9%',
        promoAdvanTitle: '数据分析 ',
        promoAdvanDescription: '市场分析、竞品分析、本品分析、受众分析;'
      }, {
        iconName: 'ico_yishenggongzuozhan_meilifangan',
        iconSize: '12.5vw',
        iconPosition: '-8%',
        iconLeft: '-9%',
        promoAdvanTitle: '推广方案',
        promoAdvanDescription: '根据分析数据与传播目标，匹配最佳媒体投放组合，规划传播策略与推广方案;'
      }, {
        iconName: 'koubei',
        iconSize: '11.5vw',
        iconPosition: '14%',
        iconLeft: '12%',
        promoAdvanTitle: '创意投放 ',
        promoAdvanDescription: '通过文案、海报、视频、话题营销等各种类型的传播方式，为品牌宣传;'
      }, {
        iconName: 'shuju',
        iconSize: '15.5vw',
        iconPosition: '-28%',
        iconLeft: '-30%',
        promoAdvanTitle: '数据检测',
        promoAdvanDescription: '根据推广情况监测各渠道数据效果，及时优化反馈;'
      }, {
        iconName: 'youhuayunhang',
        iconSize: '11.5vw',
        iconPosition: '8%',
        iconLeft: '6%',
        promoAdvanTitle: '实时优化',
        promoAdvanDescription: '运营团队全程跟进，实时优化推广方案，以达到最佳传播效果;'
      }
      ],
      bigDataContent: [
        {
          bigDataTitle: '市场分析',
          bigDataP1: '市场规模',
          bigDataP2: '行业现状',
          bigDataP3: '市场投放'
        },
        {
          bigDataTitle: '竞品分析 ',
          bigDataP1: '竞品特点',
          bigDataP2: '竞品投放',
          bigDataP3: '竞品卖点'
        },
        {
          bigDataTitle: '自身分析 ',
          bigDataP1: '品牌现状',
          bigDataP2: '品牌特点',
          bigDataP3: '投放情况'
        },
        {
          bigDataTitle: '用户分析 ',
          bigDataP1: '用户年龄',
          bigDataP2: '用户属性',
          bigDataP3: '用户习惯'
        }
      ]
    }
  },
  methods: {},
  components: {
    IndexHeader,
    IndexSidebar,
    IndexFooter
  }
}



// WEBPACK FOOTER //
// ./src/pages/solution/finance/index.vue